import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { FETCH_SITE_CONTENT } from './SiteMapActions';

const INITIAL_STATE = {
  errors: null,
  content: [],
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  let data = _.get(action, 'payload.data', []);
  let newState = {
    ...INITIAL_STATE,
    ...state,
    ...errors,
  };

  switch (action.type) {
    case FETCH_SITE_CONTENT: {
      data = _.map(data, row => {
        const url = _.get(row, 'url', '');
        const newUrl = url.endsWith('/') ? url : `${url}/`;
        const subUrls = _.get(row, 'subUrls', []);
        const newSubUrls = _.map(subUrls, subRow => {
          const subUrl = _.get(subRow, 'url', '');
          const newSubUrl = subUrl.endsWith('/') ? subUrl : `${subUrl}/`;
          return {
            ...subRow,
            url: newSubUrl,
          };
        });
        return {
          ...row,
          url: newUrl,
          subUrls: newSubUrls,
        };
      });
      newState = {
        ...newState,
        errors,
        content: data,
      };
      return newState;
    }
    default:
      return newState;
  }
}
